module.exports = __webpack_public_path__ + "img/restoration.75150704.jpg";